module.exports = __webpack_public_path__ + "img/semAgendamento.cf76e27d.png";